import { Module } from '@/types';

export const ALL_MODULES: Module[] = [
    {
        module_id: 'clients',
        name: 'Clientes',
        description: 'Gestión de socios y miembros del gimnasio',
        min_plan: 'basic',
        icon: 'Users',
        price: 0,
    },
    {
        module_id: 'memberships',
        name: 'Membresías',
        description: 'Control de planes y pagos',
        min_plan: 'basic',
        icon: 'CreditCard',
        price: 0,
    },
    {
        module_id: 'scanner',
        name: 'Scanner QR',
        description: 'Control de acceso mediante QR',
        min_plan: 'basic',
        icon: 'QrCode',
        price: 10,
    },
    {
        module_id: 'inventory',
        name: 'Inventario',
        description: 'Control de stock y ventas',
        min_plan: 'professional',
        icon: 'Package',
        price: 10,
    },
    {
        module_id: 'classes',
        name: 'Clases',
        description: 'Gestión de clases grupales y horarios',
        min_plan: 'professional',
        icon: 'Calendar',
        price: 15,
    },
    {
        module_id: 'reports',
        name: 'Reportes',
        description: 'Métricas y estadísticas avanzadas',
        min_plan: 'professional',
        icon: 'BarChart3',
        price: 20,
    },
    {
        module_id: 'webhooks',
        name: 'WhatsApp / Webhooks',
        description: 'Notificaciones automáticas y n8n',
        min_plan: 'enterprise',
        icon: 'Webhook',
        price: 25,
    },
    {
        module_id: 'sales',
        name: 'Ventas (POS)',
        description: 'Punto de venta e ingresos de inventario',
        min_plan: 'professional',
        icon: 'ShoppingCart',
        price: 15,
    },
    {
        module_id: 'expenses',
        name: 'Gestión de Gastos',
        description: 'Control de egresos y costos operativos',
        min_plan: 'professional',
        icon: 'FileText',
        price: 10,
    },
    {
        module_id: 'employees',
        name: 'Gestión de Empleados',
        description: 'Horarios, asistencia y nómina del personal',
        min_plan: 'professional',
        icon: 'UserCog',
        price: 15,
    },
    {
        module_id: 'nutricion',
        name: 'Nutrición',
        description: 'Planes alimenticios, macros y control antropométrico',
        min_plan: 'professional',
        icon: 'Apple',
        price: 15,
    },
    {
        module_id: 'rewards',
        name: 'Recompensas',
        description: 'Ofertas y dinámicas para socios (ruleta y rachas)',
        min_plan: 'professional',
        icon: 'Gift',
        price: 10,
    },
    {
        module_id: 'facturacion',
        name: 'Facturación electrónica',
        description: 'Emisión de DTE (facturas) con proveedores certificados por Hacienda',
        min_plan: 'professional',
        icon: 'Receipt',
        price: 25,
    },
];
